<div id="globalGlobalContainer">
  <div id="GreekParallax"></div>
<div id="globalContainer">
<div id="header">
  <nav>
    <a routerLink="/dashboard">Dashboard</a>
    <a routerLink="/articles">Myth Classed</a>
    <a routerLink="/familyTree">Family Tree</a>
    <a routerLink="/galery">Gallery</a>
  </nav>
  </div>

    
    <div id="container" *ngIf="article">

      <div id="name">The myth behind : <span style="font-weight: 600;">{{article.name }}</span></div>
      <div id="title">{{article.title}}</div>
      <div id="content">
      <img id="image" src="{{article.imageUrl}}" alt="{{article.name}} image failed to load : {{article.imageUrl}} "/>
      {{article.description}}</div>
      <div id="writeBy">Written by {{article.author}}</div>

      <div id="containerUpdate">
        Modify the Content ? <input type="checkbox" (click)="modifyDisplay()"/>
        <div *ngIf="displayUpdate" ><br>
          Copy paste your Update here, or change it in direct right now :<br>
          NB: Don't forget to Save.
          <textarea id="modifier"  [(ngModel)]="article.description"></textarea><br>
          <button (click)="save()">Save</button>
        </div>
      </div>
    </div>
</div>

<app-messages></app-messages>
<div id="GreekParallax"></div>
</div>